import { useContext } from "react";
import PendingContext from "../components/PendingContext";

export function useSessionPending(context = PendingContext): any {
    const contextValue = useContext(context);
    return contextValue.session;
}